import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-4_3",
  "use": "icon-4_3-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-4_3\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" /> \n\t<path d=\"M22,3H2A2,2,0,0,0,0,5V19a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V5A2,2,0,0,0,22,3Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol